import React, { FC } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import SocialLinkRowItemLazy from './SocialLinkRowItemLazy';
import AppStoreLinkLazy from '../AppStoreLink/AppStoreLinkLazy';
import { SocialLinkRowItemProps } from './SocialLinkRowItem';
import { SocialLinkRow_viewer } from './__generated__/SocialLinkRow_viewer.graphql';

import style from './SocialLinkRow-style.scss';

type Props = {
    items: SocialLinkRowItemProps[];
    isClient: boolean;
    viewer: SocialLinkRow_viewer;
};
export const SocialLinkRowComponent: FC<Props> = ({ items, viewer = {}, isClient }) =>
    isClient ? (
        <li>
            <ul className={style.row}>
                {items.map(item => (
                    <React.Suspense fallback={''} key={item.name}>
                        <SocialLinkRowItemLazy {...item} />
                    </React.Suspense>
                ))}
                {viewer.isDownloadAppEnabled && (
                    <li>
                        <AppStoreLinkLazy />
                    </li>
                )}
            </ul>
        </li>
    ) : null;

export const SocialLinkRow = createFragmentContainer(SocialLinkRowComponent, {
    viewer: graphql`
        fragment SocialLinkRow_viewer on Viewer {
            isDownloadAppEnabled: isEnabledByLocale(featureName: "DOWNLOAD_APP")
        }
    `,
});
